/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 10:40:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

import { http } from '@shared';

const getHouseList = () => {
  return http.request({
    url: '/api/ipc/house/houseList',
  });
};

export { getHouseList };
